import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { DocumentUrl } from "../../models/cartable.model";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Button, Grid } from "@mui/material";
import ModalCancel from "../modals/ModalCancel";

export default function LoadDocumentCmp(props: any) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  const [widthDiv, setWidthDiv] = useState<any>(0);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const reference = React.useRef(null);
  const [dimensions, setDimensions] = useState<any>({ width: 0, height: 0 });
  const queryClient = useQueryClient();
  useEffect(() => {
    if (reference.current) {
      setDimensions({
        width: reference?.current,
        height: reference.current,
      });
    }
    setWidthDiv(dimensions.width.offsetWidth);
  }, [textWidth]);
  let classText: any;
  if (textWidth + 20 > widthDiv) {
    classText = "paraghramImage infoText";
  }

  const getTextWidthInPixels = (ref: HTMLSpanElement) =>
    ref != null ? ref.getBoundingClientRect().width : 0;

  useEffect(() => {
    setTextWidth(getTextWidthInPixels(spanRef.current!));
  }, [spanRef]);

  let isValue;
  if ((props.title == true && props.data) || props?.data?.fileType! === "PDF") {
    isValue = true;
  } else if (props.title == false && props.data) {
    isValue = false;
  }
  let typeFiles;
  let type;
  if (props?.data?.fileType! === "Image") {
    typeFiles = <img src={props.data.fileUrl} className='uploadImage' />;
    type = "jpg";
  } else if (props?.data?.fileType! == "PDF") {
    typeFiles = (
      <PictureAsPdfOutlinedIcon
        className={
          props.parentPage == "furtherInfo"
            ? "uploadImageCmpIconPDF"
            : "uploadImageCmpIconPDFfurtherInfo "
        }
        // style={{ marginTop: "1vh" }}
      />
    );
    type = "pdf";
  } else if (
    props?.data?.fileType! === "ZIP" ||
    props?.data?.fileType! === "RAR"
  ) {
    typeFiles = <FolderZipOutlinedIcon className='uploadImageCmpIcon ' />;
    type = "RAR";
  } else if (props.type == "xlsx") {
    typeFiles = <InsertDriveFileOutlinedIcon className='uploadImageCmpIcon ' />;
    type = "xlsx";
  } else {
    typeFiles = <InsertDriveFileOutlinedIcon className='uploadImageCmpIcon ' />;
    type = "jpg";
  }
  const openModalDeleteImage = () => {
    setOpenModal(!openModal);
  };
  const deleteDocument = useMutation(props.serviceName, {
    onSuccess: async (data: boolean) => {
      if (data) {
        if (props.cacheName != undefined) {
          let supplierAttachments = queryClient.getQueryData<DocumentUrl[]>(
            props.cacheName
          );
          supplierAttachments?.map((item: any) => {
            if (item.fileId === props.data.fileId) {
              item.fileUrl = undefined;
              return;
            }
          });
          queryClient.setQueryData(props.cacheName, supplierAttachments);
          props.setChildValue(queryClient.getQueryData(props.cacheName));
        } else if (
          props.attachments !== undefined &&
          props.attachments.length > 0
        ) {
          let attachmentsTemprory = props?.attachments?.filter(
            (x: { fileId: any }) => x.fileId != props.data.fileId
          );
          props.setChildValue(attachmentsTemprory);
        } else {
          props.setChildValue(undefined);
        }
      }
    },
    onError: (err) => {},
  });

  const deleteImage = () => {
    if (props.serviceRequestObj !== undefined) {
      deleteDocument.mutate(props.serviceRequestObj);
    } else if (props.multiItem !== undefined && props.multiItem) {
      let supplierAttachments = props?.attachments?.filter(
        (item: any) => item.fileUrl !== props.data.fileUrl
      );

      props.setChildValue(supplierAttachments);
    } else {
      props.setChildValue(undefined);
    }
  };

  const handleOpenImage = () => {
    const imageUrl = props.data.fileUrl
      ? `${props.data.fileUrl}/true`
      : props.data;

    if (!imageUrl) {
      alert("آدرس تصویر وجود ندارد.");
      return;
    }

    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      alert("پنجره جدید توسط مرورگر مسدود شده است.");
      return;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>نمایش تصویر</title>
      <style>
      @font-face {
      font-family: "iranSansMedium";
      src: url("/fonts/IRANSansBold.ttf");
      }
      html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      }
      body {
      background-color: #fff;
      margin: 0;
      font-family: "iranSansMedium";
      min-height: 100vh;
      min-width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      }
      .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 20vh;
      flex: 1;
      overflow: hidden;
      }
      img {
      max-width: 90vw;
      max-height: 80vh;
      min-width: 40%;
      min-height: 40%;
      transition: transform 0.3s ease, width 0.3s, height 0.3s;
      border: 1px solid #ddd;
      display: block;
      margin: 0 auto;
      object-fit: contain;
      cursor: default;
      }
      img.zoom-cursor {
      cursor: zoom-in;
      }
      img.zoomed {
      cursor: zoom-out;
      z-index: 10;
      }
      .buttons {
      margin-top: 20px;
      position: static;
      text-align: center;
      }
      button {
      height: 5vh;
      background-color: #3498db;
      color: white;
      border: none;
      padding: 7px 20px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
      border-radius: 5px;
      font-family: "iranSansMedium";
      display: inline-flex;
      align-items: center;
      gap: 5px;
      }
      button .icon {
      font-family: "iranSansMedium";
      font-size: 1.3rem;
      vertical-align: middle;
      position: relative;
      top: 3px;
      }
      button:hover {
      background-color: #2980b9;
      }
      </style>
    </head>
    <body>
      <div class="image-container">
      <img id="rotatableImage" src="${imageUrl}" alt="تصویر" />
      </div>
      <div class="buttons">
      <button onclick="rotate(-90)"><span class="icon">⟲</span> چرخش به چپ</button>
      <button onclick="rotate(90)">چرخش به راست <span class="icon">⟳</span></button>
      </div>
      <script>
      let angle = 0;
      let scale = 1;
      function rotate(deg) {
      angle = (angle + deg) % 360;
      updateTransform();
      // Adaptive resizing for 90/270 degrees
      const img = document.getElementById("rotatableImage");
      if (Math.abs(angle % 180) === 90) {
        img.style.maxWidth = "80vh";
        img.style.maxHeight = "90vw";
      } else {
        img.style.maxWidth = "90vw";
        img.style.maxHeight = "80vh";
      }
      }
      function updateTransform() {
      const img = document.getElementById("rotatableImage");
      img.style.transform = "rotate(" + angle + "deg) scale(" + scale + ")";
      }
      // Initial resize in case image is already rotated
      rotate(0);

      // Zoom on hover/click
      const img = document.getElementById("rotatableImage");
      img.classList.add('zoom-cursor');
      let zoomed = false;
      img.addEventListener('mouseenter', function() {
      img.classList.add('zoom-cursor');
      });
      img.addEventListener('mouseleave', function() {
      img.classList.remove('zoom-cursor');
      img.classList.remove('zoomed');
      scale = 1;
      updateTransform();
      zoomed = false;
      });
      img.addEventListener('click', function() {
      zoomed = !zoomed;
      if (zoomed) {
        scale = 2;
        img.classList.add('zoomed');
      } else {
        scale = 1;
        img.classList.remove('zoomed');
      }
      updateTransform();
      });
      </script>
    </body>
    </html>
    `;

    newWindow.document.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };
  return (
    <div
      className={props.className ? props.className : "UploadImageCmp"}
      style={{
        height: props.height ? props.height : "",
      }}
    >
      <>
        {isValue ? (
          <>
            {props.picName !== "storePic" && (
              // <a
              //   href={`${props.data.fileUrl!}/true`}
              //   target="_blank"
              //   rel="noopener noreferrer"
              // >
              //   {typeFiles}
              // </a>
              <a
                // onClick={(e) => {
                //   if (props.picName === "storePic") {
                //     e.preventDefault(); // جلوگیری از باز شدن لینک
                //     handleOpenImage(); // اجرای تابع
                //   }
                // }}
                onClick={() => handleOpenImage()}
                href={props.data?.fileUrl ? `${props.data.fileUrl}/true` : "#"}
                target='_blank'
                rel='noopener noreferrer'
              >
                {typeFiles}
              </a>
            )}
            {
              <div
                className='row rowUploadImage'
                style={props.data.createDate_Persian ? { height: "38%" } : {}}
              >
                <div
                  className='col-12 cont'
                  style={{ color: "#fff" }}
                  ref={reference}
                >
                  <p
                    className={classText ? classText : "paraghramImage"}
                    style={{ marginTop: "0.9vh" }}
                  >
                    <span
                      ref={spanRef}
                      contentEditable
                      suppressContentEditableWarning
                      onInput={() =>
                        setTextWidth(getTextWidthInPixels(spanRef.current!))
                      }
                    >
                      {props.data.documentTypeTitle}
                    </span>
                    {props.data.createDate_Persian && (
                      <>
                        <br />
                        <span> {props.data.createDate_Persian}</span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            }
          </>
        ) : (
          <>
            <a
              // onClick={
              //   props.picName === "storePic"
              //     ? () => handleOpenImage()
              //     : undefined
              // }
              onClick={() => handleOpenImage()}
              href={
                props.picName !== "storePic"
                  ? `${props?.data?.fileUrl!}/true`
                  : undefined
              }
              target='_blank'
              rel='noopener noreferrer'
              style={{
                height: props.height ? props.height : "",
                display: props.display ? props.display : "",
              }}
            >
              {props.document ? (
                <img
                  src={`data:image/png;base64,${props.document}`}
                  className={
                    props.className2
                      ? props.className2
                      : "uploadImage verticalImageloadDocument "
                  }
                  alt=''
                />
              ) : (
                <img
                  src={props?.data?.fileUrl! || props?.data}
                  className={
                    props.className2
                      ? props.className2
                      : "uploadImage verticalImageloadDocument "
                  }
                  alt=''
                />
              )}
            </a>
            {props.deleteIcon ? (
              <Grid
                container
                style={{
                  position: props.position ? props.position : undefined,
                  bottom: props.bottom ? props.bottom : undefined,
                  left: props.left ? props.left : undefined,
                  margin: props.margin ? props.margin : undefined,
                  textAlign: "left",
                  // background: "red",
                }}
              >
                <Grid item xs={12}>
                  <Button
                    style={{
                      backgroundColor: "#34495E",
                      zIndex: "1",
                      position: "relative",
                      borderRadius: "50%",
                      width: "4vh",
                      minWidth: " 4vh",
                      height: "4vh",
                      textAlign: "center",
                      alignContent: "center",
                    }}
                    onClick={openModalDeleteImage}
                  >
                    <DeleteOutlineOutlinedIcon style={{ color: "#fff" }} />
                  </Button>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </>
        )}
      </>
      {openModal === true ? (
        <ModalCancel
          title={""}
          bgColor={"kamanColor"}
          setValue={deleteImage}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : (
        ""
      )}
    </div>
  );
}
